import { Button, Carousel, Image } from "antd";
import dataJson from "@/../public/data.json";
import { useEffect, useState } from "react";
import phoneImg from "@/pages/freeDownload/images/phone.png";
import emailImg from "@/pages/freeDownload/images/email.png";
import { FREE_DOWNLOAD_PATH } from "@/utils/base";
import { useGetLoginInfo } from "@/hooks/useGetLoginInfo";
import "./index.less";
import { useLocation } from "react-router-dom";
import { getServiceVal } from "@/utils/cookies";

import Banner from "@/components/Banner";

const prefix = "home";

function Home() {
  const location = useLocation();
  const { authorization, portalAuthorization, goLogin } = useGetLoginInfo();

  const { free_download } = dataJson;

 

  useEffect(() => {
    console.log("location =>", location.hash);
    if (location.hash) {
      const hash = location.hash.replace("#", "");
      const jumpEle = document.getElementById(hash);
      if (jumpEle) {
        jumpEle.scrollIntoView();
      }
    }
  }, [location]);

  const toUrl = (item: any) => {
    window.open(`${item.url}`);
  };

  return (
    <div className={prefix}>
      <Banner pageKey={"home"} />

      {/* KaihongOS架构图及图文介绍模块 */}
      <div className={`${prefix}-framework`}>
        <div className={`${prefix}-title`}>{free_download.framework.title}</div>
        <div className={`${prefix}-arch-img`}>
          <Image src={free_download.framework.arch_img} />
        </div>
        {free_download.framework.items.map((item: any, index: number) => {
          return (
            <div key={index} className={`${prefix}-item`}>
              <div className={`${prefix}-item-image`}>
                <img src={item.image} alt="framework-item-image" />
              </div>
              <div className={`${prefix}-item-text`}>
                <div className={`${prefix}-item-title`}>{item.title}</div>
                <div className={`${prefix}-item-describe`} dangerouslySetInnerHTML={{ __html: item.describe }}></div>
              </div>
            </div>
          );
        })}
      </div>

      {/* --版本分类--区块 */}
      <div className={`${prefix}-version-classification`}>
        <div className={`${prefix}-content`}>
          <div className={`${prefix}-title`}>{free_download.version_classification.title}</div>
          <div className={`${prefix}-card-wrap`}>
            {free_download.version_classification.list.map((item: any, index: number) => {
              return (
                <div key={index} className={`${prefix}-cardV`}>
                  <div className={`${prefix}-cardV-title`} style={{ backgroundImage: `url(${item.title_bg})` }}>
                    {item.title}
                  </div>
                  <div className={`${prefix}-cardV-describe`}>{item.describe}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* --开发类型--区块 */}
      <div className={`${prefix}-development-type`}>
        <div className={`${prefix}-content`}>
          <div className={`${prefix}-title`}>{free_download.development_type.title}</div>
          {free_download.development_type.list.map((listItem: any, listIndex: number) => {
            return (
              <dl key={listIndex}>
                <dt>{listItem.title}</dt>
                {listItem.items.map((item: any, index: number) => {
                  return (
                    <dd key={index}>
                      <span>{item.title}</span>
                      <span dangerouslySetInnerHTML={{ __html: item.describe }}></span>
                    </dd>
                  );
                })}
              </dl>
            );
          })}
        </div>
      </div>

      {/* 开发套件板块 */}
      <div className={`${prefix}-develop-KIT`} style={{ backgroundImage: `url(${free_download.develop_KIT.bg_img})` }} id="develop-KIT">
        <div className={`${prefix}-content`}>
          <div className={`${prefix}-title`}>{free_download.develop_KIT.title}</div>
          <div className={`${prefix}-describe`}>{free_download.develop_KIT.describe}</div>
          <dl>
            <dt>{free_download.develop_KIT.sub_title}</dt>
            {free_download.develop_KIT.steps.map((item: any, index: number) => {
              return (
                <dd key={index}>
                  <span className={index === free_download.develop_KIT.steps.length - 1 ? "step-complete" : ""}>
                    {index === free_download.develop_KIT.steps.length - 1 ? "" : index + 1}
                  </span>
                  <div dangerouslySetInnerHTML={{ __html: item }}></div>
                </dd>
              );
            })}
          </dl>
        </div>
      </div>

      <div id="support"></div>
      {/* 开发板&支持  */}
      <div className={`${prefix}-support`}>
        <dl className={`${prefix}-content`}>
          <dt>{free_download.support.title}</dt>
          <dd>
            <p className="text-title">{free_download.support.sub_title}</p>
            {free_download.support.sub_desc}
          </dd>
          <dd className="text-image">
            {free_download.support.list.map((item: any, index: number) => {
              return (
                <div key={index} className="text-image-item" onClick={() => toUrl(item)}>
                  <div className="img" style={{ backgroundImage: `url(${require(`../freeDownload/images/${item.title}.png`)})` }}></div>
                  {/* <img src={require(`./images/${item.title}.png`)} alt="" /> */}
                  <p className="text-subtitle">{item.title}</p>
                  {item.describe}
                </div>
              );
            })}
          </dd>
          <dd className="text-third-title">{free_download.support.contact_text}</dd>
          <dd>
            <img src={phoneImg} />
            <span>{free_download.support.phone_text}</span>
          </dd>
          <dd>
            <img src={emailImg} />
            <span>{free_download.support.email_text}</span>
          </dd>
        </dl>
      </div>
    </div>
  );
}

export default Home;
